import { render, staticRenderFns } from "./PotentialSignals.vue?vue&type=template&id=0544c4cc&scoped=true"
import script from "./PotentialSignals.vue?vue&type=script&lang=js"
export * from "./PotentialSignals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0544c4cc",
  null
  
)

export default component.exports